<div class="login-reminder is-flex-column has-flex-content-center has-flex-align-center" *appShowAuthed="false">
  <div class="hide-on-desktop-up wrapper">
    <h4 class="is-flex has-flex-content-center has-flex-align-center">
      <a (click)="onClick($event)" class="is-flex has-flex-align-center">{{ 'my-remax.saved-searches.register-login' | translate }}
        <i class="material-icons">chevron_right</i>
      </a>
    </h4>
    <p class="text text-center">{{ 'my-remax.saved-searches.login-prompt' | translate }} </p>
  </div>
  <div class="hide-on-desktop-down" [class.modal-footer]="isModal" *appShowAuthed="false" >
    <div [class.login-reminder-text]="isModal">
      <span (click)="openRegisterLogin()" class="is-flex has-flex-align-center">{{ 'my-remax.saved-searches.register-login' | translate }} to {{ 'my-remax.saved-searches.login-prompt' | translate }}</span>
    </div>
  </div>
</div>
